<template>
    <div class="welfare">
        <div class="bannerList" :style="{backgroundImage:`url('static/homepage/banner1.jpg')`}">
        </div>
        <div class="liucheng full-width">
            <div class="container">
                <h2>福利解决方案及流程</h2>
                <img src="static/gift/welfare/tanxin.png" alt="">
                <img src="static/gift/welfare/dingzhi.png" alt="">
                <img src="static/gift/welfare/zhixuan.png" alt="">
            </div>
        </div>
        <div class="goodness full-width" :style="{backgroundImage:`url('static/gift/welfare/goodness.png')`}">
            <div class="container">
                <ul>
                    <li>
                        <p>根据企业预算需求
                        </p>
                        <p>提供多样化解决方案</p>
                    </li>
                    <li>
                        <p>整合各类优质资源
                        </p>
                        <p>支持自有供应商接入</p>
                    </li>
                    <li>
                        <p>大数据分析员工偏好
                        </p>
                        <p>满足员工个性化需求</p>
                    </li>
                    <li>
                        <p>自选福利品类丰富
                        </p>
                        <p>各消费场景全覆盖</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="whyus full-width">
            <div class="container">
                <img src="static/gift/welfare/why.png" alt="">
                <img class="maru" src="static/gift/welfare/crical.png" alt="">
                <h2>信赖，源自于他们的选择</h2>
                <div class="clearfix">
                    <div class="why-item fl">
                        <img src="static/gift/welfare/dianda1.png" alt="">
                        <img src="static/gift/welfare/dianda2.png" alt="">
                    </div>
                    <div class="why-item fl">
                        <img src="static/gift/welfare/ccyc.png" alt="">
                        <img src="static/gift/welfare/ccyc2.png" alt="">
                    </div>
                    <div class="why-item fl">
                        <img src="static/gift/welfare/szgj.png" alt="">
                        <img src="static/gift/welfare/szgj2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "welfare",
        metaInfo: {
            title: '福分通-福利发放', // set a title
            meta: [{                 // set meta
                name: '福分通',
                content: '专注企业员工福利'
            }]
        },
    }
</script>

<style scoped lang="stylus">
    .bannerList
        position absolute
        top 0
        z-index -1
        width 100%
        min-width 1200px
        height 640px
        display block
        overflow hidden
        text-align center
        background-size cover
        background-position center

    h2
        font-size 36px
        font-weight bold

    .liucheng
        text-align center
        padding-top 100px
        padding-bottom 100px
        h2
            color black
            margin-bottom 80px

    .goodness
        height 500px
        text-align center
        padding-top 50px
        background-position center
        background-size cover
        ul
            display block
            position absolute
            width 1180px
            top 360px
            li
                display inline-block
                width 25%
                cursor pointer
                &:hover p
                    color #0239f5
                p
                    font-size 16px
                    color white
                    font-weight bold
                    line-height 28px

    .whyus
        background-color #f2f2f2
        text-align center
        padding-top 100px
        padding-bottom 100px
        .maru
            position absolute
            top 250px
            left 446px
            animation round 3s infinite linear
        @keyframes round {
            from {
                transform rotate(0deg)
            }
            to {
                transform rotate(360deg)
            }
        }
        h2
            margin-top 100px
            margin-bottom 80px
            color black
        .why-item
            width 380px
            height 240px
            margin-right 20px
            overflow hidden
            &:last-child
                margin-right 0
            img
                transition 0.5s ease-in-out
            &:hover img
                transform translateY(-100%)
</style>